var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionLikeFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33293 14.8854C6.58813 13.8381 4.96497 12.6056 3.4925 11.2098C2.45729 10.2046 1.66919 8.97917 1.18858 7.62736C0.323697 5.00502 1.33394 2.00295 4.16115 1.1145C5.64702 0.647993 7.26982 1.69856 8.52189 2.61493C9.77445 1.69968 11.3967 0.649203 12.8826 1.1145C15.7099 2.00295 16.7274 5.00502 15.8625 7.62736C15.3819 8.97917 14.5938 10.2046 13.5586 11.2098C12.0861 12.6056 10.4629 13.8381 8.71813 14.8854L8.52916 15L8.33293 14.8854Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionLikeFilled);
export default __webpack_public_path__ + "static/media/action-like-filled.b56ab60f0cb57297caf772c3c0e7aacf.svg";
export { ForwardRef as ReactComponent };